import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

const funcionDefault = { nombreFuncion: '', guardarEn: '', parametros: [] };
const dataTypes = ['texto', 'imagen', 'audio', 'video', 'documento'];

const AristaForm = ({ nodo, nodos, archivos, guardarArista, arista, editing, functionesChatbot }) => {
	const [nuevaArista, nuevaAristaChanged] = useState(arista);

	return (
		<div style={{ width: '80%', margin: '40px auto' }}>
			<div align='right'>
				<div className='taby'>{editing ? 'Editar' : 'Crear'} Arista</div>
			</div>
			<div className='form-container'>
				<DestSelection nuevaArista={nuevaArista} nuevaAristaChanged={nuevaAristaChanged} nodos={nodos} nodo={nodo} />
				<Scripts nuevaArista={nuevaArista} nuevaAristaChanged={nuevaAristaChanged} archivos={archivos} />
				<Buttons nuevaArista={nuevaArista} nuevaAristaChanged={nuevaAristaChanged} />
				<Conditions nuevaArista={nuevaArista} nuevaAristaChanged={nuevaAristaChanged} />
				<Functions nuevaArista={nuevaArista} nuevaAristaChanged={nuevaAristaChanged} functionesChatbot={functionesChatbot} />
				<SaveDelete nuevaArista={nuevaArista} nodo={nodo} guardarArista={guardarArista} />
			</div>
		</div>
	);
};

export default AristaForm;

function toggle_variable(parametro) {
	if (parametro[0] === '&') {
		parametro = parametro.slice(1, -1);
	} else {
		parametro = '&' + parametro + '*';
	}
	return parametro;
}

//#region Seccion para la seleccion del nodo destino

function DestSelection({ nuevaArista, nuevaAristaChanged, nodos, nodo }) {
	return (
		<div>
			<b style={{ marginRight: 10 }}>Del nodo {nodo.nodo} a: </b>
			<select
				onChange={(e) =>
					nuevaAristaChanged({
						...nuevaArista,
						nodoDestino: Number(e.target.value),
						nombre: '' + nodo.nodo + '_' + e.target.value,
					})
				}
				value={nuevaArista.nodoDestino}
			>
				<option key='default' value={0}>
					Selecciona un Nodo...
				</option>
				{nodos.map((nodo) => (
					<option key={nodo.nodo} value={nodo.nodo}>
						Nodo {nodo.nodo} ({nodo.nombre})
					</option>
				))}
			</select>
		</div>
	);
}

//#endregion

//#region Seccion de los scripts

function Scripts({ nuevaArista, nuevaAristaChanged, archivos }) {
	return (
		<div>
			{nuevaArista.scripts &&
				nuevaArista.scripts.map((script, index) => {
					// script => {tipo:XXXX, valor:XXXX, externo:XXXX}
					switch (script.tipo) {
						case 'imagen':
							return (
								<MultimediaScript
									key={index}
									index={index}
									nuevaArista={nuevaArista}
									nuevaAristaChanged={nuevaAristaChanged}
									archivos={archivos.imagenes}
								/>
							);
						case 'audio':
							return (
								<MultimediaScript
									key={index}
									index={index}
									nuevaArista={nuevaArista}
									nuevaAristaChanged={nuevaAristaChanged}
									archivos={archivos.audios}
								/>
							);
						case 'video':
							return (
								<MultimediaScript
									key={index}
									index={index}
									nuevaArista={nuevaArista}
									nuevaAristaChanged={nuevaAristaChanged}
									archivos={archivos.videos}
								/>
							);
						case 'documento':
							return (
								<MultimediaScript
									key={index}
									index={index}
									nuevaArista={nuevaArista}
									nuevaAristaChanged={nuevaAristaChanged}
									archivos={archivos.documentos}
								/>
							);
						default:
							return <TextScript key={index} index={index} nuevaArista={nuevaArista} nuevaAristaChanged={nuevaAristaChanged} />;
					}
				})}
			<button
				className='add-button rectangle'
				onClick={() =>
					nuevaAristaChanged({
						...nuevaArista,
						scripts: [...nuevaArista.scripts, { tipo: 'texto', valor: '', externo: false }],
					})
				}
			>
				+
			</button>
		</div>
	);
}

function TextScript({ index, nuevaArista, nuevaAristaChanged }) {
	return (
		<div>
			<hr />
			<b>Script {index + 1}</b>
			<br />
			<div>
				<textarea
					onChange={(e) => {
						const newScripts = nuevaArista.scripts;
						newScripts[index] = {
							tipo: 'texto',
							valor: e.target.value,
							externo: false,
						};
						nuevaAristaChanged({
							...nuevaArista,
							scripts: newScripts,
						});
					}}
					value={nuevaArista.scripts[index].valor}
					style={{ width: '60%', height: 64, resize: 'none' }}
				></textarea>

				<button
					onClick={() =>
						nuevaAristaChanged({
							...nuevaArista,
							scripts: [...nuevaArista.scripts.slice(0, index), ...nuevaArista.scripts.slice(index + 1)],
						})
					}
					className='remove-button'
					style={{ position: 'absolute' }}
				>
					x
				</button>
			</div>

			<div style={{ marginTop: '10px' }}>
				<span style={{ marginRight: '5px' }}>Tipo de script</span>
				<select
					onChange={(e) => {
						const newScripts = nuevaArista.scripts;
						newScripts[index] = {
							tipo: e.target.value,
							valor: '',
							externo: false,
						};
						nuevaAristaChanged({
							...nuevaArista,
							scripts: newScripts,
						});
					}}
					value={nuevaArista.scripts[index].tipo}
				>
					{dataTypes.map((type) => (
						<option key={type} value={type}>
							{type}
						</option>
					))}
				</select>
			</div>
		</div>
	);
}

function MultimediaScript({ index, nuevaArista, nuevaAristaChanged, archivos }) {
	return (
		<div>
			<hr />
			<b>Script {index + 1}</b>
			<br />
			<div style={{ marginTop: '10px' }}>
				{!nuevaArista.scripts[index].externo ? (
					<select
						onChange={(e) => {
							const newScripts = nuevaArista.scripts;
							newScripts[index].valor = e.target.value;
							nuevaAristaChanged({
								...nuevaArista,
								scripts: newScripts,
							});
						}}
						value={nuevaArista.scripts[index].valor}
					>
						<option key='' value=''>
							Selecciona un archivo
						</option>
						{archivos.map((file) => (
							<option key={file} value={file}>
								{file}
							</option>
						))}
					</select>
				) : (
					<span>
						<span style={{ marginRight: '15px' }}>URL del archivo:</span>
						<input
							style={{ width: '500px' }}
							value={nuevaArista.scripts[index].valor}
							onChange={(e) => {
								const newScripts = nuevaArista.scripts;
								newScripts[index].valor = e.target.value;
								nuevaAristaChanged({
									...nuevaArista,
									scripts: newScripts,
								});
							}}
						/>
					</span>
				)}

				<button
					onClick={() =>
						nuevaAristaChanged({
							...nuevaArista,
							scripts: [...nuevaArista.scripts.slice(0, index), ...nuevaArista.scripts.slice(index + 1)],
						})
					}
					className='remove-button'
					style={{ position: 'absolute' }}
				>
					x
				</button>
			</div>
			<div style={{ marginTop: '10px' }}>
				<span>¿El archivo es externo?</span>
				<input
					type='checkbox'
					checked={nuevaArista.scripts[index].externo}
					onChange={() => {
						const newScripts = nuevaArista.scripts;
						newScripts[index].externo = !newScripts[index].externo;
						newScripts[index].valor = '';
						nuevaAristaChanged({
							...nuevaArista,
							scripts: newScripts,
						});
					}}
				/>
			</div>
			<div style={{ marginTop: '10px' }}>
				<span style={{ marginRight: '5px' }}>Tipo de script</span>
				<select
					onChange={(e) => {
						const newScripts = nuevaArista.scripts;
						newScripts[index] = {
							tipo: e.target.value,
							valor: '',
							externo: false,
						};
						nuevaAristaChanged({
							...nuevaArista,
							scripts: newScripts,
						});
					}}
					value={nuevaArista.scripts[index].tipo}
				>
					{dataTypes.map((type) => (
						<option key={type} value={type}>
							{type}
						</option>
					))}
				</select>
			</div>
		</div>
	);
}

//#endregion

//#region Seccion para la creacion de botones

function Buttons({ nuevaArista, nuevaAristaChanged }) {
	return (
		<div>
			<br />
			<hr />
			<div>
				<b>Botones</b>
			</div>
			<div
				style={{
					display: 'flex',
					justifyContent: 'flex-start',
					flexWrap: 'wrap',
				}}
			>
				{nuevaArista.botones &&
					nuevaArista.botones.map((boton, index) => {
						return (
							<div key={index} style={{ margin: 10 }}>
								<small>Opcion {index + 1}</small>
								<button
									onClick={() =>
										nuevaAristaChanged({
											...nuevaArista,
											botones: [...nuevaArista.botones.slice(0, index), ...nuevaArista.botones.slice(index + 1)],
										})
									}
									className='remove-button'
								>
									x
								</button>
								<br />
								<input
									onChange={(e) =>
										nuevaAristaChanged({
											...nuevaArista,
											botones: [...nuevaArista.botones.slice(0, index), e.target.value, ...nuevaArista.botones.slice(index + 1)],
										})
									}
									value={nuevaArista.botones[index]}
								></input>
							</div>
						);
					})}
				<button
					onClick={() =>
						nuevaArista.botones
							? nuevaAristaChanged({
									...nuevaArista,
									botones: [...nuevaArista.botones, ''],
							  })
							: nuevaAristaChanged({ ...nuevaArista, botones: [''] })
					}
					className='add-button'
					style={{ width: 80, height: 80, marginTop: 10 }}
				>
					+
				</button>
			</div>
		</div>
	);
}

//#endregion

//#region Seccion para la creacion y eliminacion de condiciones

function Conditions({ nuevaArista, nuevaAristaChanged }) {
	const condicionesDefaultObj = {
		intent: { esIntent: true, nombreIE: 'intent', condicional: '', valor: '' },
		entity: { esIntent: false, nombreIE: '', condicional: '', valor: '' },
		variable: { variable: '', condicional: '', valor: '' },
	};

	const [creandoCondicion, setCreandoCondicion] = useState(false);

	return (
		<div>
			<br />
			<hr />
			<div>
				<b style={{ marginRight: 20 }}>Condiciones</b>
				{nuevaArista.condiciones && nuevaArista.condiciones.length > 1 && (
					<div style={{ display: 'inline' }}>
						<small>Relación: </small>
						<input
							placeholder='Ej: * AND *'
							onChange={(e) =>
								nuevaAristaChanged({
									...nuevaArista,
									operacion: e.target.value,
								})
							}
							value={nuevaArista.operacion}
						/>
					</div>
				)}
			</div>
			<div
				style={{
					display: 'flex',
					justifyContent: 'flex-start',
					flexWrap: 'wrap',
				}}
			>
				{nuevaArista.condiciones &&
					nuevaArista.condiciones.map((condicion, index) => {
						return (
							<div key={index} style={{ margin: 10 }}>
								<button
									onClick={() =>
										nuevaAristaChanged({
											...nuevaArista,
											condiciones: [...nuevaArista.condiciones.slice(0, index), ...nuevaArista.condiciones.slice(index + 1)],
											operacion: nuevaArista.condiciones.length <= 2 ? '' : nuevaArista.operacion,
										})
									}
									className='remove-button'
									style={{ marginLeft: '65px' }}
								>
									x
								</button>
								<br />
								{condicion.variable !== undefined && (
									<>
										<small>Variable</small>
										<br />
										<input
											onChange={(e) =>
												nuevaAristaChanged({
													...nuevaArista,
													condiciones: [
														...nuevaArista.condiciones.slice(0, index),
														{
															...nuevaArista.condiciones[index],
															variable: e.target.value,
														},
														...nuevaArista.condiciones.slice(index + 1),
													],
												})
											}
											value={nuevaArista.condiciones[index].variable}
										></input>
										<br />
									</>
								)}
								{condicion.esIntent === false && (
									<>
										<small>Nombre Entity</small>
										<br />
										<input
											onChange={(e) =>
												nuevaAristaChanged({
													...nuevaArista,
													condiciones: [
														...nuevaArista.condiciones.slice(0, index),
														{
															...nuevaArista.condiciones[index],
															nombreIE: e.target.value,
														},
														...nuevaArista.condiciones.slice(index + 1),
													],
												})
											}
											value={nuevaArista.condiciones[index].nombreIE}
										></input>
										<br />
									</>
								)}
								<small>Condicional</small>
								<br />
								<select
									onChange={(e) =>
										nuevaAristaChanged({
											...nuevaArista,
											condiciones: [
												...nuevaArista.condiciones.slice(0, index),
												{
													...nuevaArista.condiciones[index],
													condicional: e.target.value,
												},
												...nuevaArista.condiciones.slice(index + 1),
											],
										})
									}
									value={nuevaArista.condiciones[index].condicional}
								>
									<option key='default' value=''>
										Selecciona una condición
									</option>
									<option key='==' value='=='>
										Igual a
									</option>
									<option key='!=' value='!='>
										Diferente a
									</option>
									<option key='<' value='<'>
										Menor a
									</option>
									<option key='<=' value='<='>
										Menor o igual a
									</option>
									<option key='>' value='>'>
										Mayor a
									</option>
									<option key='>=' value='>='>
										Mayor o igual a
									</option>
								</select>
								<br />
								<small>
									Valor <b>{condicion.variable !== undefined ? 'Variable' : condicion.esIntent ? 'Intent' : 'Entity'}</b>
								</small>
								<br />
								<input
									onChange={(e) =>
										nuevaAristaChanged({
											...nuevaArista,
											condiciones: [
												...nuevaArista.condiciones.slice(0, index),
												{
													...nuevaArista.condiciones[index],
													valor: e.target.value,
												},
												...nuevaArista.condiciones.slice(index + 1),
											],
										})
									}
									value={nuevaArista.condiciones[index].valor}
								></input>
								<br />
							</div>
						);
					})}
				{creandoCondicion ? (
					<div>
						<button onClick={() => addCondicion(condicionesDefaultObj.intent)} className='toggle-button'>
							Intent
						</button>
						<br />
						<button onClick={() => addCondicion(condicionesDefaultObj.entity)} className='toggle-button'>
							Entity
						</button>
						<br />
						<button onClick={() => addCondicion(condicionesDefaultObj.variable)} className='toggle-button'>
							Variable
						</button>
					</div>
				) : (
					<button onClick={() => setCreandoCondicion(true)} className='add-button square'>
						+
					</button>
				)}
			</div>
		</div>
	);

	function addCondicion(nuevaCond) {
		if (nuevaArista.condiciones) {
			nuevaAristaChanged({
				...nuevaArista,
				condiciones: [...nuevaArista.condiciones, nuevaCond],
			});
		} else {
			nuevaAristaChanged({ ...nuevaArista, condiciones: [nuevaCond] });
		}
		// setTimeout(() => {
		// 	setCreandoCondicion(false);
		// }, 2000)
		setCreandoCondicion(false);
	}
}

//#endregion

//#region Seccion para la asignacion de funciones

function Functions({ nuevaArista, nuevaAristaChanged, functionesChatbot }) {
	return (
		<div>
			<br />
			<hr />

			{!nuevaArista.ejecutaFuncion && (
				<div>
					<b>Funciones que Ejecuta </b>
				</div>
			)}
			<div>
				{nuevaArista.ejecutaFuncion &&
					nuevaArista.ejecutaFuncion.map((funcion, index) => {
						return (
							<div key={index} style={{ margin: 10, textAlign: 'center' }}>
								<hr style={{ borderWidth: '2px' }} />
								<h2>Función número {index + 1}</h2>
								<h3>- {funcion.nombreFuncion} -</h3>
								<button
									onClick={() => {
										const temp = { ...nuevaArista };

										if (temp.ejecutaFuncion.length === 1) {
											delete temp.ejecutaFuncion;
										} else {
											temp.ejecutaFuncion = [...temp.ejecutaFuncion.slice(0, index), ...temp.ejecutaFuncion.slice(index + 1)];
										}

										nuevaAristaChanged(temp);
									}}
									className='remove-button'
									style={{ marginLeft: '0px' }}
								>
									x
								</button>
								<br />
								<small>Escoge la función</small>
								<br />
								<select
									onChange={(e) =>
										nuevaAristaChanged({
											...nuevaArista,
											ejecutaFuncion: [
												...nuevaArista.ejecutaFuncion.slice(0, index),
												{
													...nuevaArista.ejecutaFuncion[index],
													nombreFuncion: e.target.value,
												},
												...nuevaArista.ejecutaFuncion.slice(index + 1),
											],
										})
									}
									value={nuevaArista.ejecutaFuncion[index].nombreFuncion}
								>
									<option key='' value=''>
										Selecciona un archivo
									</option>
									{functionesChatbot.map((funcion) => (
										<option key={funcion} value={funcion}>
											{funcion}
										</option>
									))}
								</select>
								<br />
								<small>Parámetros</small>
								<br />
								{funcion.parametros &&
									funcion.parametros.map((parametro, index2) => {
										return (
											<div key={index2}>
												<input
													onChange={(e) =>
														nuevaAristaChanged({
															...nuevaArista,
															ejecutaFuncion: [
																...nuevaArista.ejecutaFuncion.slice(0, index),
																{
																	...nuevaArista.ejecutaFuncion[index],
																	parametros: [
																		...nuevaArista.ejecutaFuncion[index].parametros.slice(0, index2),
																		e.target.value,
																		...nuevaArista.ejecutaFuncion[index].parametros.slice(index2 + 1),
																	],
																},
																...nuevaArista.ejecutaFuncion.slice(index + 1),
															],
														})
													}
													value={nuevaArista.ejecutaFuncion[index].parametros[index2]}
												/>

												<button
													onClick={() =>
														nuevaAristaChanged({
															...nuevaArista,
															ejecutaFuncion: [
																...nuevaArista.ejecutaFuncion.slice(0, index),
																{
																	...nuevaArista.ejecutaFuncion[index],
																	parametros: [
																		...nuevaArista.ejecutaFuncion[index].parametros.slice(0, index2),
																		toggle_variable(nuevaArista.ejecutaFuncion[index].parametros[index2]),
																		...nuevaArista.ejecutaFuncion[index].parametros.slice(index2 + 1),
																	],
																},
																...nuevaArista.ejecutaFuncion.slice(index + 1),
															],
														})
													}
													className='toggle-button'
													style={{ wordWrap: 'unset' }}
												>
													{parametro[0] === '&' ? 'Convertir a constante' : 'Convertir a variable'}
												</button>

												<button
													onClick={() => {
														const aristaTemp = { ...nuevaArista };
														const funcion = aristaTemp.ejecutaFuncion[index];

														funcion.parametros = [...funcion.parametros.slice(0, index2), ...funcion.parametros.slice(index2 + 1)];

														aristaTemp.ejecutaFuncion[index] = funcion;

														nuevaAristaChanged(aristaTemp);
													}}
													className='remove-button'
													style={{ marginLeft: '5px' }}
												>
													x
												</button>
											</div>
										);
									})}
								<button
									onClick={() =>
										nuevaAristaChanged({
											...nuevaArista,
											ejecutaFuncion: [
												...nuevaArista.ejecutaFuncion.slice(0, index),
												{
													...nuevaArista.ejecutaFuncion[index],
													parametros: nuevaArista.ejecutaFuncion[index].parametros ? [...nuevaArista.ejecutaFuncion[index].parametros, ''] : [''],
												},
												...nuevaArista.ejecutaFuncion.slice(index + 1),
											],
										})
									}
									className='add-button rectangle'
								>
									+
								</button>
							</div>
						);
					})}
				<button
					onClick={() =>
						nuevaArista.ejecutaFuncion
							? nuevaAristaChanged({
									...nuevaArista,
									ejecutaFuncion: [...nuevaArista.ejecutaFuncion, funcionDefault],
							  })
							: nuevaAristaChanged({
									...nuevaArista,
									ejecutaFuncion: [funcionDefault],
							  })
					}
					className='add-button square'
				>
					+
				</button>
			</div>
		</div>
	);
}

//#endregion

//#region Seccion de los botones para guardado

function SaveDelete({ nuevaArista, nodo, guardarArista }) {
	const history = useHistory();

	// Las validaciones deben de regresar true cuando algo no esta validado
	// Se valida que se haya escogido un nodo de destino
	const nodoDestinoValidation = nuevaArista.nodoDestino === 0;

	// Se valida que se haya definido al menos un script de mensaje
	const scriptValidation = nuevaArista.scripts.length === 0;

	// Se valida que se hayan definido los scripts correctamente
	const scriptEmptyValidation = !nuevaArista.scripts.every((script) => script.valor !== '');

	// Se valida que no haya funciones con nombres vacios
	const functionsValidation = nuevaArista.ejecutaFuncion ? !nuevaArista.ejecutaFuncion.every((funcion) => funcion.nombreFuncion !== '') : false;

	// Se valida que la operacion entre condiciones sea congruente
	let operationValidation;
	if (nuevaArista.condiciones.length > 1) {
		operationValidation = nuevaArista.operacion.match(/\*/gi) ? nuevaArista.operacion.match(/\*/gi).length !== nuevaArista.condiciones.length : true;
	} else {
		operationValidation = false;
	}

	// Se valida que no haya condiciones con parámetros vacíos
	const condicionalValidation =
		nuevaArista.condiciones &&
		!nuevaArista.condiciones.every(
			(condicion) => condicion.condicional !== '' && condicion.nombreIE !== '' && condicion.valor !== '' && condicion.variable !== ''
		);

	return (
		<div>
			<div className='form-actions' align='right'>
				<button className='form-button secondary-button' onClick={() => history.push('/edit/' + nodo._id)}>
					Cancelar
				</button>
				<button
					disabled={
						nodoDestinoValidation || scriptValidation || condicionalValidation || operationValidation || functionsValidation || scriptEmptyValidation
					}
					onClick={() => guardarArista(nuevaArista)}
					className='form-button primary-button'
				>
					Guardar
				</button>
			</div>
			{nodoDestinoValidation && (
				<div align='right'>
					<span style={{ fontSize: '12px', color: 'red' }}>* Se debe especificar el nodo destino *</span>
				</div>
			)}
			{scriptValidation && (
				<div align='right'>
					<span style={{ fontSize: '12px', color: 'red' }}>* Debe existir al menos un script *</span>
				</div>
			)}
			{scriptEmptyValidation && (
				<div align='right'>
					<span style={{ fontSize: '12px', color: 'red' }}>* Existen scripts que no se encuentran definidos *</span>
				</div>
			)}
			{operationValidation && (
				<div align='right'>
					<span style={{ fontSize: '12px', color: 'red' }}>* El numero de asteriscos no coincide con el número de condiciones *</span>
				</div>
			)}
			{condicionalValidation && (
				<div align='right'>
					<span style={{ fontSize: '12px', color: 'red' }}>* Existen condiciones sin definir *</span>
				</div>
			)}
			{functionsValidation && (
				<div align='right'>
					<span style={{ fontSize: '12px', color: 'red' }}>* Existen funciones sin nombre *</span>
				</div>
			)}
		</div>
	);
}
